import { jsx as e, jsxs as o } from "react/jsx-runtime";
import "../../../node_modules/dayjs/locale/uk.js";
import t from "../../../node_modules/deepmerge/dist/es.js";
import { materialTheme as r, joyTheme as i } from "../../utils/theme.js";
import { GlobalStyles as l } from "@mui/joy";
import a from "@mui/joy/CssBaseline";
import { CssVarsProvider as m, THEME_ID as d } from "@mui/joy/styles";
import { Experimental_CssVarsProvider as s, THEME_ID as n } from "@mui/material/styles";
import { AdapterDayjs as c } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider as p } from "@mui/x-date-pickers/LocalizationProvider";
import { ukUA as u } from "@mui/x-date-pickers/locales";
import { getGlobalScrollStyles as f } from "./getGlobalScrollStyles.js";
const h = u.components.MuiLocalizationProvider.defaultProps.localeText, y = (e2, o2) => {
  if (!o2) return e2;
  const r2 = "function" == typeof o2 ? o2(e2) : o2;
  return t(e2, r2, { arrayMerge: (e3, o3) => o3 });
}, j = ({ children: t2, materialOverrides: u2, joyOverrides: j2 }) => {
  const M = y(r, u2), x = y(i, j2);
  return e(s, { theme: { [n]: M }, children: o(m, { theme: { [d]: x }, children: [e(a, {}), e(l, { styles: (e2) => ({ ":root": { "--joy-focus-thickness": "1px" }, body: { overflow: "hidden", height: "100vh", ...f(e2) }, ".k-animation-container": { zIndex: "100000 !important" }, ".custom-width-tooltip": { maxWidth: "60vw" }, ".MuiOption-root": { maxWidth: "60vw !important", whiteSpace: "unset !important" } }) }), e(p, { dateAdapter: c, adapterLocale: "uk", localeText: { ...h, fieldYearPlaceholder: (e2) => "Р".repeat(e2.digitAmount), fieldMonthPlaceholder: (e2) => "letter" === e2.contentType ? "MMMM" : "MM", fieldDayPlaceholder: () => "ДД", fieldWeekDayPlaceholder: (e2) => "letter" === e2.contentType ? "ТТТТ" : "ТТ", fieldHoursPlaceholder: () => "год", fieldMinutesPlaceholder: () => "хв", fieldSecondsPlaceholder: () => "сек" }, children: t2 })] }) });
};
export {
  j as ThemeProvider,
  j as default
};
//# sourceMappingURL=ThemeProvider.js.map
